const esc = (v) => String(v ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

export function printTable({ title, subtitle, columns, rows, totals = [] }) {
  const th = columns.map((c) => `<th class="${c.right ? "r" : ""}">${esc(c.label)}</th>`).join("");
  const body = rows.map((r) => `<tr>${columns.map((c) => `<td class="${c.right ? "r" : ""}">${esc(c.render ? c.render(r) : r[c.key])}</td>`).join("")}</tr>`).join("");
  const foot = totals.map((t) => `<tr><td colspan="${columns.length - 1}">${esc(t.label)}</td><td class="r">${esc(t.value)}</td></tr>`).join("");
  const w = window.open("", "_blank");
  w.document.write(`<html><head><title>${esc(title)}</title><style>
    body{font-family:Arial,sans-serif;padding:24px;color:#111}h1{margin:0 0 4px;font-size:22px}p{margin:2px 0;color:#444;font-size:12px}
    table{width:100%;border-collapse:collapse;margin-top:16px;font-size:11px}th,td{border:1px solid #999;padding:5px 6px;text-align:left}th{background:#eee}td.r,th.r{text-align:right}
    tfoot td{font-weight:bold;background:#f6f6f6}</style></head><body>
    <h1>BRIJPAL SINGH EM ROF ALTANTE 108 – ${esc(title)}</h1><p>Printed: ${new Date().toLocaleString("en-IN")}</p><p>${esc(subtitle || "")}</p>
    <table><thead><tr>${th}</tr></thead><tbody>${body}</tbody><tfoot>${foot}</tfoot></table>
    <script>window.onload=function(){window.print()}</script></body></html>`);
  w.document.close();
}

export const num = (n) => Number(n || 0).toLocaleString("en-IN");
